import { createI18n } from 'vue-i18n';

import { uiMessages } from '@ohmybible/ui';

import en from '@/locales/en.json';

import { setupValibotMessages } from './valibot';

/**
 * The app's only language is English, but every user-facing string is a key.
 * To add a language: put `locales/<lang>.json` next to `en.json` (and
 * `libs/ui/src/locales/<lang>.json` for the `ui.*` keys), import both here, add
 * them to `messages` and register the lib's in `uiMessages`. Content from the
 * API is not translated.
 */
// A shallow merge: the top-level `ui` namespace belongs to libs/ui, so the
// app's locale files never define a `ui` key.
export const messages = {
  en: {
    ...uiMessages.en,
    ...en,
  },
};

export type MessageSchema = typeof messages.en;

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  // A missing key renders as the key itself; say so loudly, so an e2e run's
  // console log catches it.
  missing: (locale, key) => {
    console.error(`[i18n] Missing message "${key}" for locale "${locale}"`);
  },
});

/** Wire the rest of the app to the active locale: <html lang> and valibot's messages. */
export const setupI18n = (): void => {
  document.documentElement.lang = i18n.global.locale.value;
  setupValibotMessages(i18n.global.t);
};
